
import Vue from 'vue'
import AppActions from '~/domain/constants/AppActions'
export default Vue.extend({
  data() {
    return {
      valid: true,
      formIsBusy: false,
      formSubmitted: false,
      formData: {
        firstName: '',
        lastName: '',
        job: '',
        email: '',
        subject: '',
        message: '',
        checkbox: true,
      },
      formRules: {
        nameRules: [
          (v) => !!v || this.$t('nameRequired'),
          (v) => (v && v.length >= 3) || this.$t('nameAtLeast3Chars'),
        ],
        emailRules: [
          (v) => !!v || this.$t('emailRequired'),
          (v) => /.+@.+\..+/.test(v) || this.$t('mailMustBeValid'),
        ],
        subjectRules: [(v) => !!v || this.$t('subjectRequired')],
        jobRules: [(v) => !!v || this.$t('jobRequired')],
        messageRules: [
          (v) => !!v || this.$t('messageRequired'),
          (v) =>
            (v && v.length >= 20) || this.$t('placeholderPleaseTypeMinChars'),
        ],
      },
    }
  },
  methods: {
    async handleSubmit() {
      if (this.$refs.form) {
        const formIsValid = (this.$refs.form as any).validate()

        if (formIsValid) {
          this.formIsBusy = true
          try {
            //check recaptcha
            //@ts-ignore
            const recaptchaToken = await this.$recaptcha.execute('contact')

            // call action to send e-mail
            const result = await this.$store.dispatch(
              'common/sendContactEmail',
              {
                context: this,
                params: {
                  recaptchaToken: recaptchaToken,
                  firstName: this.formData.firstName,
                  lastName: this.formData.lastName,
                  email: this.formData.email,
                  subject: this.formData.subject,
                  job: this.formData.job,
                  message: this.formData.message,
                },
              }
            )
            if (result.success) {
              this.$store.dispatch(AppActions.TRACK_SEGMENT_EVENT, {
                context: this,
                params: {
                  name: 'Contact - Contact form submission',
                  category: 'Contact Form',
                  action: 'Contact Form Submission',
                  label: 'contact',
                  misc: [
                    {
                      type: 'location',
                      value: 'contact',
                    },
                  ],
                },
              })
              //@ts-ignore
              await this.$refs.form.reset()
              this.formSubmitted = true
            } else {
              this.$store.commit('common/setFormSubmitError', true)
            }
            //@ts-ignore
            await this.$recaptcha.reset()
            this.formIsBusy = false
          } catch (error) {
            this.formIsBusy = false
            this.formSubmitted = false
            this.$store.commit('common/setFormSubmitError', true)
            //@ts-ignore
            await this.$recaptcha.reset()
          }
        }
      }
    },
  },
  async mounted() {
    try {
      //@ts-ignore
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  },
  beforeDestroy() {
    //@ts-ignore
    this.$recaptcha.destroy()
    this.$store.commit('common/setFormSubmitError', false)
  },
})
